import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Typography from '@hellodarwin/core/lib/components/common/typography';
import Checkmark from '@hellodarwin/icons/dist/icons/Checkmark';
import { useTheme } from 'styled-components';
import { useComponent } from '../../../../hooks/useComponent';
import useFormatBody from '../../../../utils/format-body';
import CTAsList from '../../../common/CTAsList';
import { ContactMethodRowContainer, ContactMethodRowHeader, ContactMethodsContainer, ContactMethodsDivider, ContactMethodsHeader, ContactMethodsList, } from './styles';
const ICON_SIZE = 26;
const ICON_SIZE_WITH_BODY = 20;
const ROW_THEMES = {
    withBody: {
        iconSize: ICON_SIZE_WITH_BODY,
        titleTheme: 'body2',
        bodyTheme: 'subtitle2',
        titleColor: 'grey_2',
    },
    withoutBody: {
        iconSize: ICON_SIZE,
        titleTheme: 'body1',
        bodyTheme: 'subtitle2',
        titleColor: 'grey_1',
    },
};
const ContactMethodRow = ({ entry }) => {
    var _a;
    const theme = useTheme();
    const item = useComponent(entry.sys.id, entry.sys.contentType.sys.id);
    const { body, bodyLong, richTitle, title } = (_a = item === null || item === void 0 ? void 0 : item.fields) !== null && _a !== void 0 ? _a : {};
    const titleContent = useFormatBody({ body: title, bodyLong: richTitle });
    const bodyContent = useFormatBody({ body, bodyLong });
    const rowTheme = ROW_THEMES[bodyContent ? 'withBody' : 'withoutBody'];
    return (_jsxs(ContactMethodRowContainer, { children: [_jsxs(ContactMethodRowHeader, { children: [_jsx(Checkmark, { size: rowTheme.iconSize, style: { flexShrink: 0 }, color: theme.colors[rowTheme.titleColor] }), !!titleContent && (_jsx(Typography.Title, { level: 3, elementTheme: rowTheme.titleTheme, color: theme.colors[rowTheme.titleColor], children: titleContent }))] }), !!bodyContent && (_jsx(Typography, { elementTheme: rowTheme.bodyTheme, style: { paddingLeft: theme.spacing.sm + rowTheme.iconSize }, children: bodyContent }))] }));
};
const ContactMethodsLayout = ({ body, bodyLong, CTAs, items, title, }) => {
    const bodyContent = useFormatBody({ body, bodyLong });
    return (_jsxs(ContactMethodsContainer, { children: [(!!title || !!bodyContent) && (_jsxs(ContactMethodsHeader, { children: [!!title && (_jsx(Typography.Title, { level: 2, elementTheme: "h4", children: title })), !!bodyContent && (_jsx(Typography, { elementTheme: "body1", children: bodyContent })), _jsx(ContactMethodsDivider, {})] })), !!(items === null || items === void 0 ? void 0 : items.length) && (_jsx(ContactMethodsList, { children: items.map((entry) => (_jsx(ContactMethodRow, { entry: entry }, entry.sys.id))) })), !!(CTAs === null || CTAs === void 0 ? void 0 : CTAs.length) && _jsx(CTAsList, { CTAs: CTAs.map((cta) => cta.fields) })] }));
};
export default ContactMethodsLayout;
